module.exports = __webpack_public_path__ + "img/tab3.ec3c8524.png";